import { useGetPlayerEventsV1CmQuery } from "../../../core/api/clockmaker-player-event-api"
import PlayerEventsPage from "../common/PlayerEventsPage"
import { initialQuickLookSettings } from "./CmPlayerEventsConstants"
import CmPlayerEventsDialog from "./CmPlayerEventsDialog"

const CmPlayerEvents = () => (
    <PlayerEventsPage
        useQuery={useGetPlayerEventsV1CmQuery}
        storageKey="cm_quick_look_settings"
        initialSettings={initialQuickLookSettings}
        typeField="table"
        typeHeaderName="Table"
        DialogComponent={CmPlayerEventsDialog}
    />
)

export default CmPlayerEvents
